import validator from 'validator';
import env from '../env';

const validate = function(value, rules) {
let messages = [],
    valid = true;
    value = value + '';
    
    rules.every(
        (rule) => { 
            switch(rule[0]) {
                case 'required':
                    if (value.length < 1) {
                        valid = false;
                        messages.push('Este campo es requerido');
                        return false;
                    } 
                break;

                case 'max':
                    if (value.length > rule[1]) {
                        valid = false;
                        messages.push('No se pueden ingresar más de: ' + rule[1] + ' caracteres');
                    }
                    break;

                case 'min':
                    if (value.length < rule[1]) {
                        valid = false;
                        messages.push('Debe ingresar un mínimo de: ' + rule[1] + ' caracteres');
                    }
                    break;

                case 'boolean':
                    if (!validator.isBoolean(value)) {
                        valid = false;
                        messages.push('Debe ser true o false');
                    }
                    break;
                case 'email':
                    if (!validator.isEmail(value)) {
                        valid = false;
                        messages.push('Escriba un email válido ej: nombre@dominio.com');
                    }
                    break;
                case 'number':
                        if (!validator.isNumeric(value)) {
                        valid = false;
                        messages.push('Debe ser un número sin letras ni símbolos');
                    }
                    break;
                case 'decimal':
                    value = parseFloat(value.replace(',','.'))+'';
                    if (!validator.isDecimal(value)) {
                        valid = false;
                        messages.push('Debe ser un decimal válido ej: 12.00');
                    }
                    break;
                case 'date':
                    if (!validator.isDate(value)){
                        valid = false;
                        messages.push('Debe ser una fecha válida: ej "25/12/2016", "25-12-2016"');
                    }
                    break;
                case 'alpha_dash':
                    let reg = /^[_-\sa-zA-Z0-9]+$/;
                    if (!value.match(reg)) {
                        messages.push('Solo puede contener letras y guiones');
                    }
                    break;
                case 'rif':
                    let reg2 = /^[JVEPG]{1}\d{9}$/;
                    if (!value.match(reg2)) {
                        messages.push('El R.I.F. debe estar en el formato: J123456789 / V123456789');
                    }
                    break;
                 case 'not_zero':
                    
                    if (value === '0') {
                        messages.push('El valor no puede ser cero');
                    }
                    break;

                case 'ret_pn':
                    let sustraendo = 0, minimo = 0;

                    sustraendo = env.UND_TRIBUTARIA * 0.003 * 8.3334 * 100;

                    minimo = Math.round(sustraendo / 3 * 100); 
                    
                    if (parseFloat(value) <= minimo) {
                        messages.push('La base de la retención para personas naturales debe ser mayor a ' + minimo.bs());
                    }

                    break;
            }
            return true;
        }
    );
    
    return messages;
};


export default validate;


/** WEBPACK FOOTER **
 ** ./app-react/services/validation.js
 **/